import "../css/master.css";
import { Link, useLocation } from "react-router-dom";
import UserInfoCom from "./userinfo";
import { logout } from "../api/api";



function SideBar() {

    const { pathname } = useLocation();


    if (pathname === "/" || pathname === "/fcc_login") {
        return (
            <div>
            </div>
        );
    }

    let isNewInquiry = ["/inquiry_create", '/inquiry_confirm', '/inquiry_completion', '/file_info_edit', '/file_info_confirm', '/file_upload', '/file_upload_complete', '/file_complete'].includes(pathname) ? true : false;
    let isInquiryStatus = ["/inquiry_status", '/relation_inquiry_create', '/relation_inquiry_confirm'].includes(pathname) ? true : false;
    let isUserInfoModify = ["/user_info_edit", '/user_info_confirm', '/user_info_completion'].includes(pathname) ? true : false;

    function NewInquiry() {
        if (isNewInquiry) {
            return <li className="is-current"><span><Link to="/inquiry_create" state={{
                endUser: "",
                hwNum: "",
                osVer: "",
                operationType: "",
                reapearance: "",
                title: "",
                question: "",
                attachedFile: "",
                emailList: [],
                emailSize: 1,
                mainMail: "",
                dialogValue: [],
                hWList: [],
                hWSize: 1,
                sWList: [],
                sWSize: 1,
                page: true,
                emailReset: true
            }} style={{ color: "white" }} aria-current="true">お問い合わせ(新規)</Link></span></li>
        } else {
            return <li><span><Link to="/inquiry_create" state={{
                endUser: "",
                hwNum: "",
                osVer: "",
                operationType: "",
                reapearance: "",
                title: "",
                question: "",
                attachedFile: "",
                emailList: [],
                emailSize: 1,
                mainMail: "",
                dialogValue: [],
                hWList: [],
                hWSize: 1,
                sWList: [],
                sWSize: 1,
                page: true,
                emailReset: true
            }}>お問い合わせ(新規)</Link></span></li>
        }
    }
    function InquiryStatus() {
        if (isInquiryStatus) {
            return <li className="is-current"><span><Link to="/inquiry_status" style={{ color: "white" }} aria-current="true" state={{ page: false }}>お問い合わせ(継続/状況確認)</Link></span></li>
        } else {
            return <li><span><Link to="/inquiry_status" state={{ page: true }}>お問い合わせ(継続/状況確認)</Link></span></li>
        }
    }
    function UserInfoModify() {
        if (isUserInfoModify) {
            return <li className="is-current"><span><Link to="/user_info_edit" state={{ page: true }} style={{ color: "white" }} aria-current="true">利用者情報変更</Link></span></li>
        } else {
            return <li><span><Link to="/user_info_edit" state={{ page: true }}>利用者情報変更</Link></span></li>
        }
    }

    return (
        <div className="ls-col str-column-side" id="ls-row-3-col-1-row-2-col-1">
            <nav className="nav-local" data-current-layer="2">
                <h2 className="str-hidden">ローカルナビゲーション</h2>
                <UserInfoCom />
                <div className="ls-row content" id="ls-row-3-col-1-row-2-col-1-row-1-col-2-row-1" aria-hidden="false">
                    <ul className="list">
                        <NewInquiry />
                        <InquiryStatus />
                        <UserInfoModify />
                        <li><span><Link to="/about_contact_center" target="_blank">ご利用にあたって</Link></span>
                        </li>
                        <li><span><Link to="/" onClick={logout}>ログアウト</Link></span>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    );
}

export default SideBar;